import { BRAND } from "../../lib/brand";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative w-full bg-[#F6F2EC] py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1480px] px-6 md:px-10 lg:px-14 text-center">
        <span
          data-testid="footer-logo"
          className="block select-none"
          style={{
            color: "#2B2320",
            fontFamily: "'Inter', sans-serif",
            fontWeight: 300,
            letterSpacing: "0.42em",
            textTransform: "uppercase",
            fontSize: "1rem",
            paddingLeft: "0.42em",
          }}
        >
          musemi
        </span>

        <p className="mt-8 font-editorial-italic text-[#2B2320] text-xl md:text-2xl">
          {BRAND.tagline}
        </p>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10">
          <a
            href="/faq"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-faq"
            className="eyebrow text-[#8A827D] hover:text-[#2B2320] transition-colors"
          >
            FAQ
          </a>
          <a
            href={BRAND.instagram.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram"
            className="eyebrow text-[#8A827D] hover:text-[#2B2320] transition-colors"
          >
            Instagram — {BRAND.instagram.handle}
          </a>
          <a
            href="mailto:hello@musemi.co"
            data-testid="footer-email"
            className="eyebrow text-[#8A827D] hover:text-[#2B2320] transition-colors"
          >
            hello@musemi.co
          </a>
        </div>
      </div>
    </footer>
  );
};
